import styled from 'styled-components'
import { useSearchBox } from 'react-instantsearch-hooks-web'
import React from 'react'

const SearchInput = (): JSX.Element => {
  const { refine } = useSearchBox()

  React.useEffect(() => {
    const element = document.getElementById('mobile-search-bar')
    element?.focus()
  }, [])

  return (
    <Input
      id="mobile-search-bar"
      placeholder="Search People and Videos"
      onChange={(e) => refine(e.target.value)}
    />
  )
}

export default SearchInput

const Input = styled.input`
  border-style: none;
  border-color: none;
  width: 100%;
  background-color: none;
  background: none;
  color: white;
  margin: 0 5px;
  font-weight: 500;
  height: 100%;
  -moz-appearance: textfield;
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  ::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  &:focus {
    outline: none;
  }
`
